import React from 'react';

import {Trans} from '../../libs/shared/core/src/helpers/internationalization/react';
import {
  CustomFieldFormAnswer,
  QualBotResponse,
} from '../../libs/shared/core/src/models/api/chatBotTranscriptResponseModel';

/*
 * Helpers.
 */

// Some multiple choice fields have a label. Display that instead of the 'value' which is always lowercase.
export function maybeRenderQualBotAnswerLabel(response: QualBotResponse) {
  if (response.responseLabel) {
    return response.responseLabel;
  }

  return renderFieldAnswer(response.response);
}

function renderFieldAnswer(answer: CustomFieldFormAnswer) {
  if (typeof answer === 'boolean') {
    return answer ? (
      <Trans id="message-viewer-chat-boolean-true">Yes</Trans>
    ) : (
      <Trans id="message-viewer-chat-boolean-false">No</Trans>
    );
  }

  if (typeof answer === 'number') {
    return String(answer);
  }

  // Empty response for non-required fields.
  if (!answer) {
    return <Trans id="message-viewer-chat-no-response">(No response)</Trans>;
  }

  return answer;
}
